import { ReactNode } from "react";

import { Box, Icon, Inline, Link, Tag, useBreakpoint } from "@seneca/senekit";
import { LocationShape } from "@seneca/senekit/out/types";

import { SUBSCRIPTION_TIERS } from "seneca-common/features/subscriptions/features/subscription-products/state/models/state/subscription-products/subscription-product/productDescription/ProductDescription";

import { getTierNameHeader } from "features/subscriptions/helpers";

export default function PlanTag({
  plan,
  link
}: {
  plan: SUBSCRIPTION_TIERS | null;
  link?: string | LocationShape;
}) {
  const label = !plan ? "FREE" : getTierNameHeader(plan)?.toUpperCase();
  const tone = !!plan ? "premium" : "primary";

  const { isMobileOnly } = useBreakpoint();
  return (
    <LinkWrapper link={link}>
      <Tag
        size={isMobileOnly ? "xsmall" : "small"}
        tone={tone}
        strength="weakWithOutline"
      >
        <Inline alignItems="center" space="small">
          <Box whiteSpace="nowrap">{label}</Box>
          {link && (
            <Icon iconName="info" accessibilityLabel="more information" />
          )}
        </Inline>
      </Tag>
    </LinkWrapper>
  );
}

function LinkWrapper({
  link,
  children
}: {
  link?: string | LocationShape;
  children: ReactNode;
}) {
  if (!link) return <>{children}</>;
  return <Link to={link}>{children}</Link>;
}
